import { useIntl } from '@grandvisionhq/state';

const useAccessibleName = (item)=>{
    const { getLabel  } = useIntl();
    return !!item.facetTerm ? `${item.facetTerm}` : `${item.sku} - ${getLabel('products.variant.description.screenreader.fallback')}`;
};

export { useAccessibleName };
//# sourceMappingURL=useAccessibleName.js.map
